import { InformationSection } from '@periscopes/general';
import React from 'react';
import { SalesforceDescription } from '@ui/text';

export interface ValidationRuleInformationProps {
	sonarObjectId: number;
}

export const ValidationRuleInformation: React.FC<ValidationRuleInformationProps> = ({ sonarObjectId }) =>
	<InformationSection sonarObjectId={ sonarObjectId }>
		<SalesforceDescription sonarObjectId={ sonarObjectId } />
	</InformationSection>;

